<template>
  <div class="navbar fixed-top navbar-expand-lg bg-white bd-bottom pe-4">
    <router-link to="/" class="navbar-brand d-flex align-items-center">
      <div class="bg-black py-1 px-2 d-flex align-items-center me-3">
        <img src="@/assets/commercelab.png" class="w-100">
      </div>
      <h4 class="text-black m-0 fw-bold">STORE NAME</h4>
    </router-link>
    <button type="button" class="navbar-toggler" data-bs-toggle="collapse" data-bs-target="#navbar" aria-controls="navbar" aria-expanded="false" aria-label="Toggle navigation"></button>
    <div class="collapse navbar-collapse" id="#navbar">
      <ul class="navbar-nav ms-auto">
        <li class="nav-item me-5">
          <div class="admin-wrap d-flex align-items-center justify-content-between fw-bold">
            <i class="fas fa-user-circle"></i>
            Admin Store
          </div>
        </li>
        <li class="nav-item me-4">
          <base-input type="search" placeholder="Search" v-model="search" :icon="'search'" :fcSize="'lg'"></base-input>
        </li>
        <li class="nav-item me-4">
          <base-button bg="gray" icon="bell">
          </base-button>
        </li>
        <li class="nav-item me-4">
          <base-button bg="gray" icon="headset">
          </base-button>
        </li>
        <li class="nav-item me-4">
          <base-button bg="gray" icon="cog">
          </base-button>
        </li>
        <li class="nav-item me-4">
          <base-button bg="gray" icon="sign-out-alt">
          </base-button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import BaseInput from '@/components/input/BaseInput'
import BaseButton from '@/components/BaseButton'
export default {
  components: {
    BaseInput,
    BaseButton
  },
  data(){
    return {
      search: ''
    }
  }
}
</script>

<style>

</style>